import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {concat, Observable, of} from 'rxjs';
import {map, switchMap, toArray} from 'rxjs/operators';
import * as lodash from 'lodash';
import {BaseUnitMessageService} from '../../base/base-unit-message.service';

@Injectable({
  providedIn: 'root'
})
export class UnitMessageService extends BaseUnitMessageService {
  protected unitId: number;
  constructor(
    protected http: HttpClient,
  ) {
    super(http);
  }

  protected getSearchModelName(): string {
    return 'UnitMessageSearch';
  }

  protected getUrl(): string {
    return environment.apiBasepoint + 'unit/' + this.unitId.toString() + '/message';
  }


  public getUnitMessages(unitId: number, timestampFrom: number, timestampTo: number, enableTrackFilter: boolean): Observable<Array<any>> {
    this.unitId = unitId;
    return this.getMessages(timestampFrom, timestampTo, enableTrackFilter);
  }
}
